import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpStoreService } from './http-store.service';
import { v4 as uuidv4 } from 'uuid';

export const REQUEST_TAG = '$$tag';

export interface RequestIdentity {
  tag: string;
  uuid: string;
}

@Injectable({
  providedIn: 'root',
})
export class HttpCollectorInterceptor implements HttpInterceptor {
  constructor(private httpStore: HttpStoreService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const tag = request.params.get(REQUEST_TAG);

    if (tag) {
      const uuid = uuidv4();
      const newRequest = request.clone({
        params: request.params.delete(REQUEST_TAG),
      });

      const requestIdentity: RequestIdentity = {
        tag,
        uuid,
      };

      return this.httpStore.wrap(requestIdentity, next.handle(newRequest));
    } else {
      return next.handle(request);
    }
  }
}
